import { ReactNode } from 'react'

export default function ContentWrapper({
  className = '',
  children,
}: {
  className?: string
  children: ReactNode
}): React.ReactElement {
  return (
    <div className="relative z-10 isolate max-w-4xl xl:max-w-7xl w-full mx-auto flex-1 pb-8 lg:pb-0 flex">
      <section className={`relative z-10 p-4 lg:p-8 ${className}`}>{children}</section>
    </div>
  )
}
